import { Phone, PhoneOff } from "react-feather";
import styles from "./identityVoice.module.css";

const IdentityIncomingCallModal = ({
  call,
  callerName,
  onAccept,
  onDecline,
}) => {
  if (!call) return null;

  return (
    <div className={`${styles.IncomingOverlay}`}>
      <div className={`${styles.IncomingCard}`}>
        <p className={`${styles.IncomingName}`}>
          {callerName || "Unknown caller"}
        </p>
        <p className={`${styles.IncomingSubtext}`}>Incoming call…</p>
        <div className={`${styles.IncomingActions}`}>
          <button
            className={`${styles.DeclineBU}`}
            onClick={() => {
              call.reject();
              onDecline && onDecline();
            }}
          >
            <PhoneOff />
          </button>
          <button
            className={`${styles.AcceptBU}`}
            onClick={() => {
              call.accept();
              onAccept && onAccept(call);
            }}
          >
            <Phone />
          </button>
        </div>
      </div>
    </div>
  );
};

export default IdentityIncomingCallModal;
